import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import ChildSelector from '../../components/parent/ChildSelector';
import { useParentChild } from '../../contexts/ParentChildContext';
import api from '../../services/api';

const STATUS_STYLES = {
  pending: 'bg-slate-100 text-slate-600',
  graded: 'bg-green-100 text-green-800',
  na: 'bg-gray-100 text-gray-500',
};

const ParentEvaluationsPage = () => {
  const { inscriptionId } = useParentChild();
  const [tab, setTab] = useState('upcoming');
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inscriptionId) return;
    setLoading(true);
    const upcoming = tab === 'upcoming' ? '1' : '0';
    api.get(`/parent-portal/children/${inscriptionId}/evaluations`, { params: { upcoming } })
      .then((res) => { if (res.data.success) setEvaluations(res.data.data); })
      .catch(() => toast.error('Erreur de chargement'))
      .finally(() => setLoading(false));
  }, [inscriptionId, tab]);

  return (
    <div className="space-y-4">
      <ChildSelector />
      <div>
        <h2 className="text-xl font-bold text-slate-900">Évaluations</h2>
        <p className="text-sm text-slate-500">Calendrier des évaluations de votre enfant</p>
      </div>

      <div className="flex gap-2">
        {[
          { id: 'upcoming', label: 'À venir' },
          { id: 'all', label: 'Toutes' },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium ${
              tab === t.id ? 'bg-primary-600 text-white' : 'bg-white border border-slate-200 text-slate-600'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <div className="animate-spin w-6 h-6 border-2 border-primary-600 border-t-transparent rounded-full" />
        </div>
      ) : evaluations.length === 0 ? (
        <div className="bg-white rounded-xl p-8 text-center text-slate-500">Aucune évaluation</div>
      ) : (
        <div className="space-y-3">
          {evaluations.map((ev) => (
            <div key={ev.id} className="bg-white rounded-xl border border-slate-200 p-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-medium text-slate-900">{ev.lib_matiere}</h3>
                  <p className="text-sm text-slate-500">{ev.type_evaluation} — {ev.periode}</p>
                  <p className="text-xs text-slate-400 mt-1">
                    {ev.date_evaluation ? new Date(ev.date_evaluation).toLocaleDateString('fr-FR') : '—'}
                  </p>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${STATUS_STYLES[ev.note_status] || STATUS_STYLES.pending}`}>
                  {ev.note_status === 'graded' ? `Note : ${ev.note}` : ev.note_status === 'na' ? 'N/A' : 'À venir'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ParentEvaluationsPage;
